export default "/images/53186aa84dda2963b4109006fd90f3d4.avif";